'use strict';

/**
 * @function
 * @description init events for the opt in/out checkboxes
 */
exports.init = function () {
	function syncState(fieldEl, isStealth) {
		var field = $(fieldEl).data('field');
		var oppositeMode = $(fieldEl).data('opposite-mode');
		var mirrorCheck = !$(fieldEl).prop('checked');
		var oppositeBox = $('.opt-in-section input.' + field + '-' + oppositeMode);
		var optInField = $('input.' + field + '-opt-in');
		var submitBtn = $('button[type="submit"]');
		window.console.debug(isStealth, field, mirrorCheck, $(oppositeBox).prop('checked'));
		if (mirrorCheck !== $(oppositeBox).prop('checked')) {
			$(oppositeBox).prop('checked', mirrorCheck);
			$(oppositeBox).parent().toggleClass('checked');
			// prevent change event on stealth sync
			if (!isStealth) {
				$(oppositeBox).trigger('change');
			}
		}
		if ($(optInField).hasClass('required') && !$(optInField).prop('checked')) {
			$('.opt-in-errors .' + field + '-error').show();
		} else {
			$('.opt-in-errors .' + field + '-error').hide();
		}
		$(submitBtn).prop('disabled', false);
		if ($('.opt-in-errors div[class*="-error"]:visible').length > 0) {
			$(submitBtn).prop('disabled', true);
		}
	}

	$(document).ready(function () {
		if ($('div.opt-in-section').length > 0) {
			$('div.opt-in-section input[type=checkbox]').each(function () {
				syncState(this,  true);
			});
		}

		$('.opt-in-section input[type=checkbox]').on('change', function () {
			syncState(this);
		});

		$('.opt-out-section input[type=checkbox]').on('change', function () {
			syncState(this);
		});
	});
};
